import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'administrator',
    loadChildren: () => import('./_components/administrator/administrator.module').then(m => m.AdministratorModule),
  },
  {
    path: 'partners',
    // path: 'partners/:partnerId',
    loadChildren: () => import('./_components/partners/partners.module').then(m => m.PartnersModule),
  },
  {
    path: 'public',
    loadChildren: () => import('./_components/public/public.module').then(m => m.PublicModule),
  },
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
